import {
  UPLOAD_UTILITY_ATTACHMENT,
  UPLOAD_UTILITY_ATTACHMENT_SUCCESS,
  UPLOAD_UTILITY_ATTACHMENT_ERROR,
  UPLOAD_UTILITY_ATTACHMENT_EMPTY,
} from '../../actions.js';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const UploadUtilityAttachment = (state = initialState, action) => {
  switch (action.type) {
    case UPLOAD_UTILITY_ATTACHMENT:
      return { ...state, loading: true, data: null, error: null };

    case UPLOAD_UTILITY_ATTACHMENT_SUCCESS:
      return { ...state, loading: false, data: action.payload };

    case UPLOAD_UTILITY_ATTACHMENT_ERROR:
      return { ...state, loading: false, error: action.payload };

    case UPLOAD_UTILITY_ATTACHMENT_EMPTY:
      return { ...initialState };

    default:
      return state;
  }
};

export default UploadUtilityAttachment;
